/**
 * Development-only logging. No-ops in production builds.
 * - Pass a function for side effects (e.g. framework loggers).
 * - Pass a string prefix and optional values for console.log(prefix, ...args).
 */
export function devlogs(effect: () => void): void;
export function devlogs(prefix: string, ...args: unknown[]): void;
export function devlogs(
  first: string | (() => void),
  ...rest: unknown[]
): void {
  if (import.meta.env.PROD) {
    return;
  }
  if (typeof first === 'function') {
    first();
  } else {
    console.log(first, ...rest);
  }
}
